import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root'
})
export class TenantService {

  private allowedTenants = [
    '01583be4-f096-49f4-bd19-56b649a8482f', 
    '7dbd3d8d-379e-4afd-b0f5-cdca8ef69e51'
  ];

  constructor(private authService: MsalService) {}

  /**
   * Checks if the current tenant is allowed.
   * @returns {boolean} - True if the tenant is allowed, false otherwise.
   */
  isAllowedTenant(): boolean {
    const tenantId = this.getTenantId();
    return this.allowedTenants.includes(tenantId || '');
  }

  /**
   * Retrieves the tenant ID from the current user's account.
   * @returns {string | null} - The tenant ID or null if not found.
   */
  getTenantId(): string | null {
    const accounts = this.authService.instance.getAllAccounts();
    return accounts[0]?.idTokenClaims?.tid || null;
  }

}
